import React, { useState, useEffect, useRef } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import './SuccessJourney.css';

const images = [
  'https://res.cloudinary.com/dexueorjm/image/upload/v1772688744/DSC00910_pskf7v.jpg',
  'https://res.cloudinary.com/drevfgyks/image/upload/v1723254184/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/WhatsApp_Image_2024-08-05_at_16.37.20_26cb257c_catjwu.jpg',
  'https://res.cloudinary.com/drevfgyks/image/upload/v1723254184/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/WhatsApp_Image_2024-08-05_at_16.37.54_74e22d58_wwkyiv.jpg',
  'https://res.cloudinary.com/dexueorjm/image/upload/v1772688732/PHOTO-2026-03-02-09-55-15_jyrhg1.jpg'
];

const SuccessJourney = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const autoplayRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.disconnect();
    };
  }, []);

  useEffect(() => {
    startAutoplay();
    return () => stopAutoplay();
  }, [currentIndex]); // Restart timer on index change

  const startAutoplay = () => {
    stopAutoplay();
    autoplayRef.current = setInterval(() => {
      handleNextClick();
    }, 5000);
  };

  const stopAutoplay = () => {
    if (autoplayRef.current) {
      clearInterval(autoplayRef.current);
    }
  };

  const handlePrevClick = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNextClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <section
      className={`success-journey-section ${isVisible ? 'is-visible' : ''}`}
      ref={sectionRef}
    >
      <div className="success-journey-container">

        {/* Left Side: Carousel */}
        <div className="journey-carousel-wrapper">
          <div className="journey-carousel">
            {images.map((image, index) => (
              <div
                key={index}
                className={`journey-slide ${index === currentIndex ? 'active' : ''}`}
                style={{ backgroundImage: `url(${image})` }}
              >
                <div className="slide-overlay"></div>
              </div>
            ))}

            <div className="carousel-controls">
              <button
                className="control-btn prev"
                onClick={handlePrevClick}
                aria-label="Previous Slide"
              >
                <ChevronLeft size={24} />
              </button>
              <button
                className="control-btn next"
                onClick={handleNextClick}
                aria-label="Next Slide"
              >
                <ChevronRight size={24} />
              </button>
            </div>

            <div className="carousel-indicators">
              {images.map((_, index) => (
                <span
                  key={index}
                  className={`indicator ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => setCurrentIndex(index)}
                />
              ))}
            </div>
          </div>

          {/* Decorative Pattern */}
          <div className="pattern-dots"></div>
        </div>

        {/* Right Side: Content */}
        <div className="journey-content-wrapper">
          <div className="journey-content">
            <div className="section-badge">Our Legacy</div>
            <h2 className="journey-title">
              Our Success <span className="highlight">Journey</span>
            </h2>

            <div className="journey-text-block">
              <p className="lead-text">
                At Amaravathi Naturo Tech Pvt Ltd, our story is one of growth, resilience, and an unwavering commitment to the land we cultivate.
              </p>

              <div className="text-segment">
                <Quote className="quote-icon" size={24} />
                <p>
                  <strong>Values & Vision:</strong> From a small family-owned farm to a leading agricultural enterprise, we remain driven by innovation, integrity, and a deep respect for nature. We nurture the land to feed communities and foster sustainable practices for generations.
                </p>
              </div>

              <div className="text-segment">
                <p>
                  <strong>Global Impact:</strong> Founded in 2017, we have blossomed into a multifaceted business spanning across India. By embracing new technologies and strategic partnerships, we expand our reach while staying true to our core mission: feeding the future.
                </p>
              </div>
            </div>

            <div className="stats-row">
              <div className="stat-item">
                <span className="stat-number">2016</span>
                <span className="stat-label">Founded</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <span className="stat-number">India</span>
                <span className="stat-label">Nationwide</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default SuccessJourney;
